import {
  ElementController,
  TOGGLE_EVENT,
  debounce,
  selectSingle,
  afterNextPaint,
} from 'js-common';

import { MENU_CONTROLLER_ID } from './constants';

/**
 * Controller for the main menu.
 */
export default class Menu extends ElementController {
  static id = MENU_CONTROLLER_ID;

  /**
   * DOM ready.
   */
  init() {
    this.body = selectSingle('body');
    this.menuToggle = this.selectSingle('menu-toggle');
    this.primaryNav = this.selectSingle('primary-nav');

    this.menuToggleStyle = getComputedStyle(this.menuToggle);
    this.primaryNavStyle = getComputedStyle(this.primaryNav);

    this.on(this.menuToggle, TOGGLE_EVENT.toggle, this.handleMenuToggle);
    this.on(window, 'resize', debounce(this.handleWindowResize, 200));
  }

  /**
   * Check if the menu can be toggled.
   *
   * @returns {boolean}
   */
  get isMenuToggleable() {
    return this.menuToggleStyle.display !== 'none';
  }

  /**
   * Check if the menu is currently visible.
   *
   * @returns {boolean}
   */
  get isMenuVisible() {
    return this.primaryNavStyle.display !== 'none';
  }

  /**
   * Set min-height on body if the menu is open.
   */
  setHeight = () => {
    this.body.style.minHeight =
      this.isMenuToggleable && this.isMenuVisible
        ? `${this.primaryNav.clientHeight}px`
        : '0px';
  };

  /**
   * Set height on window resize.
   */
  handleWindowResize = () => {
    this.setHeight();
  };

  /**
   * Set height when the menu is toggled.
   */
  handleMenuToggle = () => {
    afterNextPaint(() => {
      this.setHeight();
    });
  };
}
